import { c as _c } from "react/compiler-runtime";
import { LiveCountdown } from '@/components/Atoms/LiveCountdown/LiveCountdown';
import { LiveNow } from '@/components/Atoms/LiveNow/LiveNow';
import type { IEvent } from '@/interfaces';
import { calculateLifeCycleState, LifeCycleState } from '@/utils/eventUtils';
import { useEffect, useState } from 'react';
import type { FCl } from 'react-fc';
interface IProps {
  event: IEvent;
}
export const EventLiveIndicator: FCl<IProps> = t0 => {
  const $ = _c(10);
  const {
    className,
    event
  } = t0;
  let t1;
  if ($[0] !== event) {
    t1 = calculateLifeCycleState(event);
    $[0] = event;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [currentLifecycleState, setLifecycleState] = useState(t1);
  const isInTimeWindow = calculateLifeCycleState(event, 60) === LifeCycleState.live;
  let t2;
  let t3;
  if ($[2] !== event) {
    t2 = () => {
      const timer = setInterval(() => {
        setLifecycleState(calculateLifeCycleState(event));
      }, 120000);
      return () => clearInterval(timer);
    };
    t3 = [event, setLifecycleState, calculateLifeCycleState];
    $[2] = event;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!isInTimeWindow) {
    return null;
  }
  if (currentLifecycleState === LifeCycleState.live) {
    let t4;
    if ($[5] !== className) {
      t4 = <LiveNow className={className} />;
      $[5] = className;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== className || $[8] !== event.startDate) {
    t4 = <LiveCountdown className={className} to={event.startDate} />;
    $[7] = className;
    $[8] = event.startDate;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};